import { IAccountMappingSubFLI, IAccountMappingTemplateGroupItemFLI } from '@modeso/types__aumico-lib-annualreport-be';

export interface IAddSubFliEvent {
    parent: IAccountMappingTemplateGroupItemFLI;
    subFli: IAccountMappingSubFLI;
}
